import React, { useState, useEffect } from "react";

import "./MedicalChart.css";
import "../../Components/Commons/Commons.css";
import "quill/dist/quill.snow.css";

//icon imports
import { useParams } from "react-router-dom";

import "chart.js/auto";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// sample imports
import SmallMenu from "../AntDMenuNavbar/AntDMenuNavbar";
import { Card } from "antd";
import { getGrowthChart } from "../../Helpers/ApiCalls/graphsApi";


function MedicalChart() {
  const { id } = useParams();
  const [data, setData] = useState({
    labels: [],
    datasets: [
      {
        label: "Creatinine",
        data: [],
        fill: true,
        backgroundColor: "#2d6e5e",
        borderColor: "#2d6e5e",
      },
    ],
  });

  // Function get growth chart API
  async function fetchCreatinineData() {
    const res = await getGrowthChart({
      patient_id: id,
      growth_chart_type: "creatinine-chart",
    });

    if (res.data) {
      // setData()
      var dateLabels = [""];
      var creatinineValues = [0];
      res.data.data.forEach((creatinine) => {
        dateLabels.push(creatinine[0]);
        creatinineValues.push(creatinine[1]);
      });
      setData({
        labels: dateLabels,
        datasets: [
          {
            label: "Creatinine",
            data: creatinineValues,
            fill: true,
            backgroundColor: "#2d6e5e",
            borderColor: "#2d6e5e",
          },
        ],
      });
    } else if (res.error) {
    }
  }

  useEffect(() => {
    fetchCreatinineData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  return (
    <div className="">
      <Card className="card-with-table">
        <div>
          <div className="col">
            <div className="row text-center">
              <div className="col-10"></div>
              <div className="col-2">
                <SmallMenu />
              </div>
              <h5 className="">Medical Chart</h5>
              <label>Source: Canete Medical and Pediatric Clinics</label>
              <div className="center">
                <Line className="line-chart" data={data} />
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
export default MedicalChart;
